import { call, put, select, takeLatest } from 'redux-saga/effects'
import { ISpecialReportsState, ISpecialReport } from '../store/specialReports.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getSpecialReportsSelector } from '../selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { SpecialReportsConstants } from '../store/specialReports.constants'
import { setSpecialReportsList } from '../store/specialReports.actions'

export function* saveSpecialReport() {
  const specialReportsState: ISpecialReportsState = yield select(getSpecialReportsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  const { specialReportsList, __currentStep, __currentSubStep, __deleteSpecialReportId, ...currentSpecialReport } =
    specialReportsState

  if (!pcrID || !currentSpecialReport.id) {
    return
  }

  try {
    let updatedSpecialReportsList = [...specialReportsList]

    if (specialReportsList && specialReportsList.length) {
      const index = specialReportsList.findIndex((report: ISpecialReport) => report.id === currentSpecialReport.id)
      if (index !== -1) {
        updatedSpecialReportsList[index] = currentSpecialReport
      } else {
        updatedSpecialReportsList.push(currentSpecialReport)
      }
    } else {
      updatedSpecialReportsList = [currentSpecialReport]
    }

    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      _specialReports: updatedSpecialReportsList,
    }

    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)

    yield put(setSpecialReportsList(updatedSpecialReportsList))
  } catch (e) {
    yield put(throwPcrException(`saveSpecialReport() error: ${e}`))
  }
}

export function* saveSpecialReportSaga() {
  yield takeLatest([SpecialReportsConstants.SAVE_SPECIAL_REPORT], performWithMutexHOG, saveSpecialReport)
}
